import { useFeatureFlag } from '../../_hooks/useFeatureFlag';
import { Feature } from '../../CommonSelectors/CommonArea.types';

export const useTabLabels = () => {
  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  return {
    Summary: 'Summary',
    Allocation: 'Allocation',
    Performance: 'Performance',
    Activity: showActivityDetails ? 'Activity' : 'Transactions',
    GainLoss: 'Gain Loss',
    Income: 'Income',
  };
};
